<template lang="html">
    <div v-show="notice.infoKick" class="el-message el-message--warning kick" style="z-index:3002;">
      <!-- <i class="el-message__icon el-icon-warning"></i> -->
      <p class="el-message__content">
        <span v-if="notice.infoKick ===1">
          {{message.Nl138}}
        </span>
        <span v-if="notice.infoKick ===2">
          {{message.Nl139}}
        </span>
        <span v-if="notice.infoKick ===3">
          {{message.Nl140}}
        </span>
        <span v-if="notice.infoKick ==='kicked'">
          {{message.Nl135}}
        </span>
        <span v-if="notice.infoKick ==='logout'">
          {{message.Nl135}}
        </span>
        <br/>
        <span class="submit" v-if="notice.infoKick === 1">
          <el-button type="primary" :loading="loading" size="mini" @click="login">{{message.Fl100}}</el-button>
          <el-button size="mini" @click="closeInfo">{{message.Fl101}}</el-button>
        </span>
        <span class="submit" v-if="notice.infoKick > 1">
          <el-button size="mini" @click="closeWindow">{{message.Fl124}}</el-button>
        </span>
        <span class="submit" v-if="notice.infoKick ==='kicked'">
          <el-button type="primary" :loading="loading" size="mini" @click="login">{{message.Al176}}</el-button>
          <el-button size="mini" @click="closeInfo">{{message.Al177}}</el-button>
        </span>
      </p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      notice: 'notice',
      app: 'app'
    })
  },
  watch: {
    'app.login': function (val) {
      if (this.notice.infoKick && val) {
        this.$store.dispatch('showKick', 0)
      }
    }
  },
  data () {
    return {
      message: {
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Fl124: this.$lang.ui.form.l124,
        Nl138: this.$lang.ui.notice.l138,
        Nl139: this.$lang.ui.notice.l139,
        Nl140: this.$lang.ui.notice.l140,
        Nl135: this.$lang.ui.notice.l135,
        Al176: this.$lang.ui.app.l176,
        Al177: this.$lang.ui.app.l177
      },
      loading: false
    }
  },
  methods: {
    closeInfo: function () {
      this.loading = false
      this.$store.dispatch('showKick', 0)
    },
    closeWindow: function () {
      this.$store.dispatch('showKick', 0)
      window.opener = null
      window.open('', '_self')
      window.close()
    },
    login: function () {
      this.loading = true
      this.$app.login(1, response => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="css" scoped>
.kick {
  width: 380px;
}
.submit {
  overflow: hidden;
  display: inline-block;
  width: 100%;
  text-align: right;
  padding-top: 15px;
}
.el-message__content {
  width: 100%;
}
</style>
